import { render, staticRenderFns } from "./RightContentBak.vue?vue&type=template&id=1e78781d&scoped=true&"
import script from "./RightContentBak.vue?vue&type=script&lang=js&"
export * from "./RightContentBak.vue?vue&type=script&lang=js&"
import style0 from "./RightContentBak.vue?vue&type=style&index=0&id=1e78781d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e78781d",
  null
  
)

export default component.exports